// src/context/SettingsProvider.js
import React, { createContext, useContext, useEffect, useState } from "react";
import { API_BASE_URL, PUBLIC_TOKEN } from "../constrants/constrant";
import axios from "axios";

const SettingsContext = createContext();

export const SettingsProvider = ({ children }) => {
  const [settings, setSettings] = useState({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios.get(`${API_BASE_URL}/settings`, {
      headers: {
        Authorization: `Bearer ${PUBLIC_TOKEN}`
      }
    })
    .then((res) => {
      console.log("Settings response:", res.data);
      setSettings(res.data.data); // ✅ API has data object
    })
    .catch((err) => console.error("Error fetching settings:", err))
    .finally(() => setLoading(false));
  }, []);

  return (
    <SettingsContext.Provider value={{ settings, loading }}>
      {children}
    </SettingsContext.Provider>
  );
};

export const useSettings = () => useContext(SettingsContext);
